$(document).ready(function() {
  const banner = $('#top-banner');
    const text = $('.scrolling-text');
    const bannerWidth = banner.width();
    let totalWidth = text.outerWidth();


    while (totalWidth < bannerWidth * 15) {
        const clone = text.clone();
        banner.append(clone);
        totalWidth += clone.outerWidth(); 
    }
    
  // // STICKY NAV BACKGROUND SWITCH /////////////////////////////////////////////////
  // const header = $("#shopify-section-header");
  // // const $submenu = $("#shopify-section-header .submenu");

  // function changeHeaderBackground() {
  //     if ($(window).scrollTop() > 0) {
  //         header.css("background", "white");
  //         // $submenu.css("background", "white");
  //     } else {
  //         header.css("background", "linear-gradient(to bottom, rgba(0, 0, 0, .25), rgba(0, 0, 0, 0))");
  //         // $submenu.css("background", "transparent");
  //     }
  // }

  // $(window).on('scroll', changeHeaderBackground);
  // changeHeaderBackground();


  $("#play-video").click(function() {
    const video = $(".hero-video").get(0);
    video.muted = false;
    video.volume = 1.0;
    video.currentTime = 0;
    video.play();
    
    $(".hero-video").attr("controls", true);
    $("#hero *:not(video)").hide();
    $("#sticky-swiper-container").css({"position": "relative", "top": "0", "margin-top": "0"});
    $(".hero-video").css({"height": "100%", "object-fit": "contain", "z-index": "9999"});
    
    if (window.innerWidth < 768) {
      $(".hero-video").attr("controls", true);
      $(".hero-video").css({"height": "100%", "object-fit": "contain", "z-index": "9999"});
      $("#hero").css("height", "auto !important");
    }
  });




  // ENTRY ANIMATION /////////////////////////////////////////////////
  const elementsToAnimate = $(".fade-in-up, .fade-in-right, .fade-in-left, .fade-in-left-translated, .fade-in-right-translated");

  const observerCallback = (entries) => {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
              $(entry.target).addClass("visible");
          }
          // THIS ELSE STATEMENT SERVES THE REMOVAL OF THE ENTRY ANIMATION WHICH ENDS UP IN A RESET
          // else {
          //     $(entry.target).removeClass("visible");
          // }
      });
  };

  const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.25
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);
  elementsToAnimate.each(function() {
      observer.observe(this);
  });


  // NUTRITIONS TABLE /////////////////////////////////////////////////
  $("#nutritions-trigger").on("click", function() {
    $("#nutritions-table").toggleClass("open");
  })


  // BURGER NAVIGATION /////////////////////////////////////////////////
  $("header .fa-bars").on("click", function() {
    if($(this).hasClass("fa-bars")) {
      $(this).removeClass("fa-bars color-1").addClass("fa-xmark color-2");
      $("#mobile-navigation").css("right", "0%")
    } else {
      $(this).removeClass("fa-xmark color-2").addClass("fa-bars color-1");
      $("#mobile-navigation").css("right", "-100%")
    };
  })
  
  $("#mobile-navigation a").each(function() {
    $(this).on("click", function() {
      $("#mobile-navigation").css("right", "-100%");
      $("header .fa-xmark").removeClass("fa-xmark color-2").addClass("fa-bars color-1");
    });
  });


  // AMBASSADOR SWIPER /////////////////////////////////////////////////
  var swiper3 = new Swiper(".ambassadorSwiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {
      800: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });


  // PRICE PER QUARTER LITRE /////////////////////////////////////////////////
  $("#product-grid .product-title").each(function() {
    let title = $(this).text();
    let can_count = title.match(/\d+/g);
    let total_cost = $(this).closest(".product").find(".price.display-none").text().replace(",", ".");;
    let litre_price = (total_cost / can_count) * (1 / .25); // corrected by swer
    let formattedPrice = litre_price.toString().slice(0, 4);
    let rendered_litre_price = formattedPrice.replace(".", ",");
    let numericString = can_count.join('');
    $(this).closest(".product").find(".litre-price").text(rendered_litre_price);
  });



  // DISPLAY THE CORRECT PRICE OF THE SELECTED PRODUCT /////////////////////////////////////////////////
  $("#display-price").text($("input[name='selected_product']:checked").data("price"));

  $("input[name='selected_product']").change(function() {
    let selectedPrice = $(this).data("price");
    let selectedProductId = $(this).val();

    $("#display-price").text(selectedPrice);
    $("#product-id").val(selectedProductId);

    $(".product-image").removeClass("highlighted");
    $(this).next(".product-image").addClass("highlighted");
  });


  // PRICE DISPLAY IN SUBSCRIPION /////////////////////////////////////////////////


  // CART DRAWER /////////////////////////////////////////////////
  $.getJSON("/cart.js", function(cart) {
    console.log(cart);
  });

  $("#open-cart-drawer").click(function() {
    updateCartDrawer();
    $(".cart-drawer").addClass("show");
    $("#overlay").show();
  });

  $(".add-to-cart-form").submit(function(e) {
    e.preventDefault();

    const form = $(this);
    const formData = form.serialize(); // creates a text string in standard URL-encoded notation

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: formData,
      dataType: "json",
      success: function() {
        updateCartDrawer();

        $(".cart-drawer").addClass("show");
        $("#overlay").show();

        const confirmationDiv = form.closest('.relative').find('.confirmation');
        confirmationDiv.addClass("slide");
        setTimeout(() => {
          confirmationDiv.removeClass("slide");
        }, 3000);

        form.find(".quantity-input").val(1);
      },
      error: function() {
        console.error("XHR Response:", xhr);
        alert("Error adding item to cart.");
      }
    });
  });

  function updateCartDrawer() {
    $.getJSON('/cart.js', function(cart) {
      let cartItemsHTML = "";
      cart.items.forEach(function(item, index) {
        const isSubscription = item.selling_plan_allocation ? true : false;

        cartItemsHTML += `
          <div class="relative cart-item flex row overflow-hidden">
            <img src="${item.image}" alt="${item.product_title}" class="is-3" style="object-fit: contain;">
            <article>
              <span class="flex row space-between align-center">
                <p class="color-1 bold">${item.product_title}</p>
                <i class="fa-light fa-trash-can color-2 remove-item" style="cursor: pointer;" data-line="${index + 1}"></i>
              </span>
              ${isSubscription ? `<p class="color-1">Abonnement: ${item.selling_plan_allocation.selling_plan.options[0].value}</p>` : ""}

              <div class="flex row space-between align-center item-qty-box">
                  <button class="cart-drawer-qty-button decrement">-</button>
                  <p class="item-quantity color-1 ta-center">${item.quantity}</p>
                  <button class="cart-drawer-qty-button increment">+</button>
              </div>
              <p class="color-2 bold">${isSubscription ? "Abo-Preis" : "Einzelpreis"}: ${(item.price / 100).toFixed(2)} €</p>
            </article>

            <div class="deletion-confirmation absolute flex row align-center justify-center gap height-100 width-100">
              <i class="fa-regular fa-trash-can color-5"></i>
              <p class="color-5 bold">Artikel entfernt</p>
            </div>
          </div>
        `;
      });

      $(".cart-items").html(cartItemsHTML);
      $("#cart-total-price").text((cart.total_price / 100).toFixed(2) + " €");
      $("#cart-items-counter p").text(cart.item_count);

      // Cart empty handling
      if (cart.item_count === 0) {
        $("#checkout-button").addClass("disabled");
        $("#cart-notice").show();
      } else {
        $("#cart-notice").hide();
        $("#checkout-button").removeClass("disabled");
        let checkoutUrl = '/checkout'; 
        $('#checkout-button').attr("onclick", `window.location.href='${checkoutUrl}'`);
      }

      removeItemEvent();
      quantityChangeEvent();
    });
  }



    function removeItemEvent() {
      $(".remove-item").click(function() {
        const lineItemIndex = $(this).data("line");
        const confirmationElement = $(this).closest('.cart-item').find('.deletion-confirmation');

        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: {
            quantity: 0,
            line: lineItemIndex
          },
          dataType: "json",
          success: function() {
            confirmationElement.show().addClass("slide");
            setTimeout(function() {
              updateCartDrawer();
            }, 2000);
          },
          error: function(xhr) {
            console.error("Error removing item:", xhr);
            alert("Error removing item from cart.");
          }
        });
      });
    }

  function quantityChangeEvent() {
      $(".increment").click(function() {
          const cartItem = $(this).closest('.cart-item');
          const lineItemIndex = cartItem.find('.remove-item').data("line");
          const quantityElement = cartItem.find('.item-quantity');
          let currentQuantity = parseInt(quantityElement.text());

          // Increment quantity
          console.log("Current Quantity before increment:", currentQuantity);
          $.ajax({
              type: "POST",
              url: "/cart/change.js",
              data: {
                  quantity: (currentQuantity + 1).toString(), // Convert to string
                  line: lineItemIndex
              },
              dataType: "json",
              success: function() {
                  updateCartDrawer();
              },
              error: function(xhr) {
                  console.error("Error changing quantity:", xhr);
                  alert("Error updating item quantity.");
              }
          });
      });

      $(".decrement").click(function() {
          const cartItem = $(this).closest('.cart-item');
          const lineItemIndex = cartItem.find('.remove-item').data("line");
          const quantityElement = cartItem.find('.item-quantity');
          let currentQuantity = parseInt(quantityElement.text());

          console.log("Current Quantity before decrement:", currentQuantity);

          if (currentQuantity > 1) { // Prevent decreasing quantity below 1
              $.ajax({
                  type: "POST",
                  url: "/cart/change.js",
                  data: {
                      quantity: (currentQuantity - 1).toString(), // Convert to string
                      line: lineItemIndex
                  },
                  dataType: "json",
                  success: function() {
                      updateCartDrawer();
                  },
                  error: function(xhr) {
                      console.error("Error changing quantity:", xhr);
                      alert("Error updating item quantity.");
                  }
              });
          } else {
              alert("Quantity cannot be less than 1.");
          }
      });
  }

  // Close cart drawer
  $("#close-cart-drawer").click(function() {
      $(".cart-drawer").removeClass("show");
      $("#overlay").hide();
  });

  $(document).click(function(event) {
      if (!$(event.target).closest(".cart-drawer, #open-cart-drawer").length) {
          if ($(".cart-drawer").hasClass("show")) {
              $(".cart-drawer").removeClass("show");
              $("#overlay").hide();
          }
      }
  });
});